import React, { useState } from 'react';
import { FileDown, AlertCircle } from 'lucide-react';
import { supabase } from '../services/db';

const CourseMaterials: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // First check if the file exists
      const { data: fileExists, error: checkError } = await supabase.storage
        .from('course-materials')
        .list(''); // List files at root level of bucket

      if (checkError) {
        throw new Error('Fehler beim Überprüfen der Datei');
      }

      const fileFound = fileExists.some(file => file.name === 'EU_AI_Act_Grundlagen.pdf');
      
      if (!fileFound) {
        throw new Error('Die angeforderte Datei ist derzeit nicht verfügbar');
      }
      
      const { data, error } = await supabase.storage
        .from('course-materials')
        .download('EU_AI_Act_Grundlagen.pdf'); // Download from root level
      
      if (error) {
        console.error('Supabase download error:', error);
        throw error;
      }
      
      // Create blob URL and trigger download
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'EU_AI_Act_Grundlagen.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading file:', error);
      setError(error instanceof Error ? error.message : 'Fehler beim Herunterladen der Datei');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Schulungsunterlagen
      </h2>
      <p className="text-gray-600 mb-6">
        Hier können Sie die begleitenden Schulungsunterlagen zum ersten Modul herunterladen.
      </p>
      
      {error && (
        <div className="flex items-center gap-2 p-4 mb-6 text-amber-700 bg-amber-50 rounded-lg border border-amber-200">
          <AlertCircle className="h-5 w-5 flex-shrink-0" />
          <p>{error}</p>
        </div>
      )}
      
      <div className="flex items-start p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors">
        <div className="flex-grow">
          <h3 className="font-medium text-gray-800 mb-1">
            EU AI Act - Grundlagen
          </h3>
          <p className="text-sm text-gray-600">
            Einführung und rechtliche Grundlagen des EU AI Acts
          </p>
        </div>
        <button
          onClick={handleDownload}
          disabled={isLoading}
          className={`flex items-center gap-2 ${
            isLoading 
              ? 'text-gray-400 cursor-not-allowed' 
              : 'text-blue-600 hover:text-blue-800'
          } ml-4`}
        >
          <FileDown className="h-5 w-5" />
          <span className="text-sm font-medium">
            {isLoading ? 'Lädt...' : 'PDF'}
          </span>
        </button>
      </div>
    </div>
  );
};

export default CourseMaterials;